function Heading() {
    return (
        <div className="row heading">
            <div className="col">
                <h3>Sudoku</h3>
                <hr></hr>
            </div>
        </div>   
    );
}

export default Heading;
